/*
 * ```
 *
 *  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *     .       .       .       .       .       .       .       .       .       .       .       .
 *       . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *   .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *     . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *    .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *       8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *    . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *       8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *    . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *       @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *    .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *      .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *    .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *      .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *    .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *       ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *    . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *         .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *    .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 *  Copyright FortyFix(c) 2026.
 *  Title: AggiornamentoMassivo.ts;
 *  Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/Modules/Klima/AggiornamentoMassivo.ts;
 *  Description: ;
 *  Author: Della Porta Giovanni Battista;
 *  Created at: 19/03/26, 10:05;
 *  Updated at: 19/03/26, 10:05;
 *  ```
 */

import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {Permission} from "../../../app/Login/_guards/Permission";

function Headers() {
  return [
    CampoAggiuntivo.TextField("Nominativo", "nominativo", "col-12", {modificabile:false}),
    CampoAggiuntivo.Html("Agente", (cliente)=>cliente.agenteObject?.nome),
    CampoAggiuntivo.Html("Categoria Commerciale", (cliente)=>cliente.tipiObject?.map(x=>x.label).join(", ")),
    CampoAggiuntivo.Html("Zona", (cliente)=>cliente.zonaObject?.label)
  ]
}

function AggiornamentoMassivo() {
  var OBJ: OggettoConfig = {
    Id: "AggiornamentoMassivo",
    RestRoute: "/anagrafica/clienti",
    ListResponseHasData:true,
    ListDefaultFilter:{page:1, size:200},
    FullExportExcel:true,
    Headers: Headers(),
    PrintHeaders: [CampoAggiuntivo.TextField("Id", "id", "col-12", {modificabile:false}), ...Headers()],
    ListMap: (data:any[])=>{
      return data.filter(x=>x.codAdhoc);
    },
    Filters:[
      CampoAggiuntivo.TextField("Nominativo", "nome"),
      CampoAggiuntivo.SingleDropdown("Agente", "agenteAdhoc", "/anagrafica/clienti/agenti", "nome", {
        //parameter:[{nome: "page", value: 0}, {nome: "size", value: 10}, {nome: "ruolo", value: "AG"}],
        //responseHasData: true
      }),
      CampoAggiuntivo.SingleDropdown("Categoria commerciale", "catCom", "/anagrafica/clienti/types", "nome", {
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: "label",
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
      }),
      {

        nome: 'Società/Ditta individuale',
        oggetti: ['tipoSocieta'],
        modificabile: true,

        source: [{id: 'SO', label: 'SOCIETA'}, {id: 'DI', label: 'DITTA INDIVIDUALE'}, {id:'P', label: 'PRIVATO'}, {id:'E', label: 'ESTERO'}, {id:'CI', label: 'CLIENTI INBEV'}],
        internalOutput: 'tipoSocietaObject',
        OutputField: 'tipoSocieta',
        OnChange: 'tipoSocietachange',
        inputType: 'singleDropdown',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'label',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-3',
        visibleifProhibited: true,
        nextDivClass: 'col-lg-12'
      },

    ],
    MenuItems:[
      {
        path: "/shared/dynamiclist/AggiornamentoMassivo",
        title: "Aggiornamento Massivo Clienti",
        icon: "fa-solid fa-people-arrows",
        class: "",
        capacita: [],
        ruoliOperativi:["SA", "AZ"]
      },
    ],
    AzioniLista:[
      {
        nome: 'Aggiorna',
        close: false,
        icon: 'fa-solid fa-rotate text-info ',
        class: ' btn ',
        labelClass: 'text-info ',
        noGet:true,
        type: 'func',
        tooltip: "Aggiorna il cliente",
        func: (cliente, api:ApiPathsService, end, toastService) => {
          api.ClassicPost("/anagrafica/clienti/get", {id: cliente.id, aggiorna:true}).subscribe(()=>{
            console.log(`azienda ${cliente.nominativo} aggiornata`);
            end();
          })

        }

      },
      {
        nome: 'View',
        close: false,
        icon: 'fa-solid fa-eye text-info ',
        class: ' btn ',
        labelClass: 'text-info ',
        noGet:true,
        type: 'func',
        tooltip: "Apri l'anagrafiva",
        hideif: {func: (x,perm: Permission)=>perm.isOperativeRoles(['SA'])},
        func: (cliente, api:ApiPathsService, end, toastService) => {
            window.open(`/listautenti/formazienda/C/${cliente.id}`);
            end()
        }

      },
    ]
  }
  return OBJ;
}


export var AggiornamentoMassivoEnv = () => {
  var env: any = {
    Modules: {
      "AggiornamentoMassivo": true
    },
    Cruds: [AggiornamentoMassivo()],
    Menu: [...AggiornamentoMassivo().MenuItems]
  }
  return env;

}
